export default "__VITE_ASSET__Or6gYot___"